/** default settings for DX Lookup */
export const dxLookupDefaults: any = {
	dropDownOptions: {
		hideOnOutsideClick: true
	},
	showClearButton: true,
	onOpened: e => {
		const popup = document.getElementById(e.component['_popupContentId']);
		const searchBox = popup.getElementsByClassName('dx-lookup-search');
		if (searchBox.length === 1) {
			const input = searchBox[0].getElementsByTagName('input');
			if (input.length === 1) {
				input[0].focus();
			}
		}
	},
};
